import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { useAnchor } from "hooks";
import { Stats1Content } from "types/graphql/generated";

interface Props {
  className?: string;
  content: Stats1Content;
}

const Stats1: VFC<Props> = withErrorBoundary(({ content: { title, stats1Stat } }) => {
  useAnchor("stats1");

  return (
    <StyledStats className="stats1">
      <div className="Content">
        <h2 className="Stats__title Font_24_32_600">{title}</h2>
        <ul className="Stats__list">
          {stats1Stat.map(({ id, text, value }) => (
            <li key={id} className="Stats__listItem">
              <Markdown className="Font_40_48_600">{value}</Markdown>
              <Markdown className="Stats__listItem_text Color_tertiary Font_18_26_600">{text}</Markdown>
            </li>
          ))}
        </ul>
      </div>
    </StyledStats>
  );
}, {});

const StyledStats = styled.section`
  margin-top: -64px;
  padding-top: 64px;

  .Stats__title {
    padding-bottom: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.fog["80"]};
  }

  .Stats__list {
    display: flex;
    justify-content: space-between;
    margin-top: 48px;
  }

  .Stats__listItem {
    max-width: 280px;
    flex: 1;

    a {
      text-decoration: underline;
    }
  }

  .Stats__listItem:not(:first-child) {
    margin-left: 20px;
  }

  .Stats__listItem_text {
    margin-top: 8px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .Stats__title {
      padding-bottom: 8px;
    }

    .Stats__list {
      flex-direction: column;
      margin-top: 40px;
    }

    .Stats__listItem:not(:first-child) {
      margin-left: unset;
      margin-top: 32px;
    }

    .Stats__listItem_text {
      margin-top: unset;
    }
  }
`;

gql`
  fragment Stats1Content on ComponentStatsStats1 {
    title
    stats1Stat {
      id
      value
      text
    }
  }
`;

export { Stats1 };
export type { Props as Stats1Props };
